// entries/fr-FR.ts
import antdFr from "antd/lib/locale/fr_FR"
import frMessages from "../locales/fr_FR.json"

const FrLang = {
  messages: {
    ...frMessages
  },
  antd: antdFr,
  locale: "fr-FR"
}

export default FrLang

